<template>
    <div id="changeDate">
        <div v-show="changeDateLt" class="changeDateLt">
            <div id="flight-date">
                <div class="date-title"><span>{{$t('message.selectFlightDate')}}</span></div>
                <div class="date-body">
                    <ul id="date-box">
                        <li v-for="(item,index) in newProductInfoList"
                            :key="index"
                            :class="{noShadow:item.errData!=='',active: flightDateSel === index}"
                            @click="flightDateSelect(index,item.errData); $bigData('flightDateClick', '选择航班日期', urlParams.orderBillCode + '+' + flightDate)">
                            <div v-if="item.errData===''" class="book">
                                <div class="flight-date-top">
                                    <div class="date">
                                        <span>{{$moment(item.date).format('MM.DD')}}</span>
                                    </div>
                                    <div class="week"><span>{{weekdaySet(item.date)}}</span></div>
                                </div>
                                <div class="flight-date-bot">
                                    <div class="suit"><span>{{$t('message.formal')}}</span>
                                        <div class="progress">
                                            <div v-if="packageWay==='0'"
                                                 class="progress-bar"
                                                 :style="'width:'+item.suit.bulkCargo.spacePercentage+'%'"></div>
                                            <div v-else
                                                 class="progress-bar"
                                                 :style="'width:'+item.suit.tray.spacePercentage+'%'"></div>
                                        </div>
                                    </div>
                                    <div class="readiness"><span>{{$t('message.spare')}}</span>
                                        <div class="progress">
                                            <div v-if="packageWay==='0'"
                                                 class="progress-bar"
                                                 :style="'width:'+item.readiness.bulkCargo.spacePercentage+'%'"></div>
                                            <div v-else
                                                 class="progress-bar"
                                                 :style="'width:'+item.readiness.tray.spacePercentage+'%'"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else
                                 class="noBook"
                                 @click.stop>
                                <div class="flight-date-top">
                                    <div class="date">
                                        <span>{{$moment(item.date).format('MM.DD')}}</span>
                                    </div>
                                    <div class="week"><span>{{weekdaySet(item.date)}}</span></div>
                                </div>
                                <div class="flight-date-bot">
                                    <div class="suit"><span>{{$t('message.formal')}}</span>
                                        <div class="progress">
                                            <div class="progress-bar" style="width: 0%;"></div>
                                        </div>
                                    </div>
                                    <div class="readiness"><span>{{$t('message.spare')}}</span>
                                        <div class="progress">
                                            <div class="progress-bar" style="width: 0%;"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="date-mask" style="top: 0;">
                                    <span v-if="item.errData.length<7" style="font-size: 18px;">{{item.errData}}</span>
                                    <span v-else-if="item.errData.length<8"
                                          style="font-size: 14px;">{{item.errData}}</span>
                                    <span v-else style="font-size: 12px;">{{item.errData}}</span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <div id="transportType">
                <div class="suitReadiness">
                    <span v-for="(item,index) in suitReadinessArr"
                          :key="index"
                          class="suitReadinessItem"
                          :class="{active:bookingPosition == index}"
                          :style="{backgroundColor: oldProductInfo.ecargoType === '1' && bookingPosition == index ?  '#727171': ''}"
                          @click="suitReadinessSel(index)">{{item}}</span>
                </div>
                <div class="bulkTray">
                    <span v-for="(item,index) in bulkTrayArr"
                          :key="index"
                          class="bulkTrayItem"
                          :class="{active:packageWay == index}"
                          :style="{backgroundColor: oldProductInfo.ecargoType === '1' && packageWay == index ?  '#727171': ''}"
                          @click="bulkTraySel(index,oldProductInfo.intoCabinType)">{{item}}</span>
                </div>
                <div style="display: flex;align-items: center;justify-content: center;flex: 0.6;border-left: 1px dashed #3e3a39;">
                    <el-checkbox disabled :value="oldProductInfo.ecargoType === '1'">电商货</el-checkbox>
                </div>
            </div>
        </div>
        <div v-show="changeDateRt" class="changeDateRt">
            <!--货延险-->
            <el-collapse-transition>
                <div v-if="!$overseasType"
                     v-show="goodsExtensionInsuranceMod"
                     id="goodsExtensionInsurance">
                    <GoodsExtensionInsuranceDialog :callback="(val)=>{insurancePlanFn(val)}"
                                                   :insuranceInfo="bookDetailData.insuranceInfo"
                                                   :userInfo="goodsExtensionInsurance.userInfo"
                                                   :init="timeStamp"
                                                   :orderBillCode="urlParams.orderBillCode"></GoodsExtensionInsuranceDialog>
                </div>
            </el-collapse-transition>

            <!--订舱信息对比-->
            <div id="orderCompare">
                <div class="orderCompareBd">
                    <div id="oldOrder" :class="{oldOrderModLeft:oldOrderModAni}">
                        <div class="oldOrderBd">
                            <div v-if="oldProductInfo.productType==='0'" class="productTypeIcon preference_self"></div>
                            <div v-else class="productTypeIcon preference_logistics"></div>
                            <div class="oldOrderInfoHd">
                                <span>{{$t('message.oldOrderInfo')}}</span>
                            </div>
                            <div class="oldOrderInfoBd">
                                <p class="productName"><span
                                        class="productNameLabel">{{$t('message.productsName')}} : </span><span
                                        class="productNameCon"
                                        :title="oldProductInfo.productName">{{oldProductInfo.productName}}</span>
                                </p>
                                <p class="shippingDate"><span
                                        class="shippingDateLabel">{{$t('message.sailDate')}} : </span><span
                                        class="shippingDateCon">{{oldProductInfo.shippingDate}}</span></p>
                                <p class="endPort"><span class="endPortLabel">{{$t('message.endPort')}} : </span><span
                                        class="endPortCon">{{oldProductInfo.destination}}</span></p>
                                <p class="bookingUnitPrice"><span class="bookingUnitPriceLabel">{{$t('message.bookingUnitPrice')}} : </span><span
                                        class="bookingUnitPriceCon"
                                        :class="{through: oldProductInfo.downUnitPrice !== ''}">{{$currencyAbbr(currencyType)}}{{oldProductInfo.unitPrice}}</span>
                                    <span v-if="oldProductInfo.downUnitPrice"
                                          style=" margin-left: 5px; color: #e73828;">{{$currencyAbbr(currencyType)}}{{oldProductInfo.downUnitPrice}}</span>
                                </p>
                                <p class="feeWeight">
                                    <span class="feeWeightLabel">计费重量 : </span>
                                    <span class="feeWeightCon"
                                          :title="oldProductInfo.feeWeight">{{ oldProductInfo.feeWeight }}</span>
                                </p>
                                <p class="bubbleRatio">
                                    <span class="bubbleRatioLabel">分泡比例 : </span>
                                    <span class="bubbleRatioCon">{{ oldProductInfo.bubbleRatio }}</span>
                                </p>
                                <p v-if="operationPrice"
                                   class="operationPrice">
                                    <span class="operationPriceLabel">操作单价 : </span>
                                    <span class="operationPriceCon">{{$currencyAbbr(currencyType)}}{{ operationPrice }}</span>
                                </p>
                                <p v-if="profitPrice"
                                   class="profitPrice">
                                    <span class="profitPriceLabel">利润单价 : </span>
                                    <span class="profitPriceCon">{{$currencyAbbr(currencyType)}}{{ profitPrice }}</span>
                                </p>
                                <p class="bookingPositions"><span class="bookingPositionsLabel">{{$t('message.bookingPositions')}} : </span><span
                                        class="bookingPositionsCon"
                                        :title="oldProductInfo.bookingPosition==='0'?$t('message.formal'):$t('message.spare')">{{oldProductInfo.bookingPosition==='0'?$t('message.formal'):$t('message.spare')}}</span>
                                </p>
                                <p class="bulkTray"><span
                                        class="bulkTrayLabel">{{$t('message.trayBulk')}} : </span><span
                                        class="bulkTrayCon"
                                        :title="oldProductInfo.packageWay==='0'?$t('message.bulk'):$t('message.tray')">{{oldProductInfo.packageWay==='0'?$t('message.bulk'):$t('message.tray')}}</span>
                                </p>
                                <p class="batteryType">
                                    <span class="batteryTypeLabel">含锂电池 : </span>
                                    <span class="batteryTypeCon" 
                                          :title="oldProductInfo.hasBatteryType === '1' ? '含' : '不含'">{{oldProductInfo.hasBatteryType === '1' ? '含' : '不含'}}</span>
                                </p>
                                <div :style="{minHeight: bookDetailData.customerCompensationRatio || bookDetailData.supplierCompensationRatio || oldProductInfo.negotiatedPrice ? '73px' : 'unset'}">
                                    <p v-if="oldProductInfo.customerCompensationRatio" class="bulkTray"><span
                                            class="bulkTrayLabel">空舱费 : </span><span
                                            class="bulkTrayCon">收取比例 : {{Number(oldProductInfo.customerCompensationRatio)}}%</span>
                                    </p>
                                    <p v-if="oldProductInfo.supplierCompensationRatio" class="bulkTray"><span
                                            class="bulkTrayLabel"><label v-if="!oldProductInfo.customerCompensationRatio">空舱费 : </label></span><span
                                            class="bulkTrayCon" 
                                            :style="{marginLeft:oldProductInfo.customerCompensationRatio ? '61px' : '0'}">赔付比例 : {{'1:' + oldProductInfo.supplierCompensationRatio.substring(0,oldProductInfo.supplierCompensationRatio.length - 2)}}</span>
                                    </p>
                                    <p v-if="oldProductInfo.negotiatedPrice" class="bulkTray"><span
                                            class="bulkTrayLabel">议价减免单价 : </span><span
                                            class="bulkTrayCon">{{'-¥' + (-Number(oldProductInfo.negotiatedPrice))}}/KG</span>
                                    </p>
                                   
                                    
                                </div>                      
                                <div style="display: flex; min-height: 73px;">                                        
                                    <div v-if="!oldProductInfo.negotiatedPrice && bookDetailData.negotiatedPriceRange" style="width: 78px; height: 30px; margin: auto; line-height: 30px; color: #fff; text-align: center; background: #d8d8d8; border-radius: 2px;">不可议价</div>                             
                                </div>     
                                

                            </div>
                            <div v-if="oldProductInfo.intoCabinType === '0'" class="oldOrderInfoTable">
                                <div class="oldOrderInfoTableHd"><span>{{$t('message.bookingData')}}</span></div>
                                <table id="oldBookSpaceTab"
                                       class="planTab"
                                       cellspacing="0">
                                    <tbody>
                                        <tr>
                                            <td>{{$t('message.bookingPieces')}}</td>
                                            <td>{{$t('message.bookingWeight')}}</td>
                                            <td>{{$t('message.bookingVolume')}}</td>
                                            <td>{{$t('message.bookingProportion')}}</td>
                                        </tr>
                                        <tr>
                                            <td class="pieces">{{oldProductInfo.bookingData.pieces}}</td>
                                            <td class="weight">{{oldProductInfo.bookingData.weight}}</td>
                                            <td class="volume">{{oldProductInfo.bookingData.volume}}</td>
                                            <td>1:<span class="proportion">{{oldProductInfo.bookingData.proportion}}</span>
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                            <div v-else class="oldIntoInfoTable">
                                <div class="oldIntoInfoTableHd"><span>{{$t('message.entryData')}}</span></div>
                                <table id="oldIntoSpaceTab"
                                       class="planTab"
                                       cellspacing="0">
                                    <tbody>
                                        <tr>
                                            <td>{{$t('message.bookingPieces')}}</td>
                                            <td>{{$t('message.bookingWeight')}}</td>
                                            <td>{{$t('message.bookingVolume')}}</td>
                                            <td>{{$t('message.bookingProportion')}}</td>
                                        </tr>
                                        <tr>
                                            <td class="pieces">{{oldProductInfo.intoCabin.pieces}}</td>
                                            <td class="weight">{{oldProductInfo.intoCabin.weight}}</td>
                                            <td class="volume">{{oldProductInfo.intoCabin.volume}}</td>
                                            <td class="proportion">{{'1:'+oldProductInfo.intoCabin.proportion}}</td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <el-collapse-transition>
                        <div v-show="newOrderMod" id="newOrder">
                            <div class="newOrderBd">
                                <div v-if="oldProductInfo.productType==='0'"
                                     class="productTypeIcon preference_self"></div>
                                <div v-else class="productTypeIcon preference_logistics"></div>
                                <div class="newOrderInfoHd">
                                    <span>{{$t('message.newOrderInfo')}}</span>
                                </div>
                                <div class="newOrderInfoBd">
                                    <p class="productName"><span class="productNameLabel">{{$t('message.productsName')}} : </span><span
                                            class="productNameCon"
                                            :title="oldProductInfo.productName">{{oldProductInfo.productName}}</span>
                                    </p>
                                    <p class="shippingDate"><span
                                            class="shippingDateLabel">{{$t('message.sailDate')}} : </span><span
                                            class="shippingDateCon change">{{flightDate}}</span></p>
                                    <p class="endPort"><span
                                            class="endPortLabel">{{$t('message.endPort')}} : </span><span
                                            class="endPortCon">{{oldProductInfo.destination}}</span></p>
                                    <p class="bookingUnitPrice"><span class="bookingUnitPriceLabel">{{$t('message.bookingUnitPrice')}} : </span><span
                                            class="bookingUnitPriceCon change">{{$currencyAbbr(currencyType)}}{{bookDetailData.realPrice}}</span>
                                    </p>
                                    <p class="feeWeight">
                                        <span class="feeWeightLabel">计费重量 : </span>
                                        <span class="feeWeightCon"
                                              :style="{color: Number(oldProductInfo.feeWeight) !== Number(bookDetailData.feeWeight) ? '#e83828' : '#3e3a39'}"
                                              :title="bookDetailData.feeWeight">{{ bookDetailData.feeWeight }}</span>
                                    </p>
                                    <p class="bubbleRatio">
                                        <span class="bubbleRatioLabel">分泡比例 : </span>
                                        <span class="bubbleRatioCon"
                                              :style="{color: oldProductInfo.bubbleRatio !== bookDetailData.bubbleRatio ? '#e83828' : '#3e3a39'}"
                                              :title="bookDetailData.bubbleRatio">{{ bookDetailData.bubbleRatio }}</span>
                                    </p>
                                    <p v-if="operationPrice"
                                       class="operationPrice">
                                        <span class="operationPriceLabel">操作单价 : </span>
                                        <span class="operationPriceCon change">{{$currencyAbbr(currencyType)}}{{ operationPrice }}</span>
                                    </p>
                                    <p v-if="profitPrice"
                                       class="profitPrice">
                                        <span class="profitPriceLabel">利润单价 : </span>
                                        <span class="profitPriceCon change">{{$currencyAbbr(currencyType)}}{{ profitPrice }}</span>
                                    </p>
                                    <p class="bookingPositions"><span class="bookingPositionsLabel">{{$t('message.bookingPositions')}} : </span><span
                                            class="bookingPositionsCon"
                                            :title="bookingPosition==='0'?$t('message.formal'):$t('message.spare')">{{bookingPosition==='0'?$t('message.formal'):$t('message.spare')}}</span>
                                    </p>
                                    <p class="bulkTray"><span class="bulkTrayLabel">{{$t('message.trayBulk')}} : </span><span
                                            class="bulkTrayCon"
                                            :title="packageWay==='0'?$t('message.bulk'):$t('message.tray')">{{packageWay==='0'?$t('message.bulk'):$t('message.tray')}}</span>
                                    </p>
                                    <p class="batteryType">
                                        <span class="batteryTypeLabel">含锂电池 : </span>
                                        <span class="batteryTypeCon"
                                              :title="oldProductInfo.hasBatteryType === '1' ? '含' : '不含'">{{ oldProductInfo.hasBatteryType === '1' ? '含' : '不含' }}</span>
                                    </p>
                                    <div :style="{minHeight: oldProductInfo.customerCompensationRatio || oldProductInfo.supplierCompensationRatio ? '74px' : 'unset'}">

                                        <p v-if="bookDetailData.customerCompensationRatio" class="bulkTray"><span
                                                class="bulkTrayLabel">空舱费 : </span><span
                                                class="bulkTrayCon">收取比例 : {{Number(bookDetailData.customerCompensationRatio)}}%</span>
                                        </p>
                                        <p v-if="bookDetailData.supplierCompensationRatio" class="bulkTray"><span
                                                class="bulkTrayLabel"><label v-if="!bookDetailData.customerCompensationRatio">空舱费 : </label></span><span
                                                class="bulkTrayCon" 
                                                :style="{marginLeft:bookDetailData.customerCompensationRatio ? '61px' : '0'}">赔付比例 : {{'1:' + bookDetailData.supplierCompensationRatio.substring(0,bookDetailData.supplierCompensationRatio.length - 2)}}</span>
                                        </p>
                                    </div>
                                   

                                    
                                    
                                </div>
                                <div style="display: flex; min-height: 73px;">
                                    <template v-if="bookDetailData.negotiatedPriceRange">
                                    
                                        <div v-if="!yijiaOpen" 
                                             style="width: 78px; height: 30px; margin: auto; line-height: 30px; color: #fff; text-align: center; cursor: pointer; background: rgba(0, 159, 232, 1); border-radius: 2px;"
                                             @click="yijiaOpen = true;$bigData('改期-申请议价','改期-申请议价','1')">申请议价</div>                              
                                        <div v-else style="padding: 10px; margin: auto; background: #fff; border-radius: 4px;">	
                                            <div style="margin-left: 10px;">
                                                <div style="font-size: 16px; font-weight: 500; color: #181818; cursor: pointer;">申请议价</div>
                                                <div style="margin-top: 5px; font-size: 16px; color: #4d4d4d;">减免单价 
                                                    <input v-model.trim="negotiatedPrice"        
                                                           style="width: 33px; padding: 3px 5px; border: 1px solid #808080; outline: 0;"
                                                           @input="inpt()" /> 元/KG <span v-if="vernegotiatedPrice" style="font-size: 11px; color: red;">不在议价范围内</span></div>
                                            </div>                                             
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div v-if="oldProductInfo.negotiatedPrice" style="width: 78px; height: 30px; margin: auto; line-height: 30px; color: #fff; text-align: center; background: #d8d8d8; border-radius: 2px;">不可议价</div>
                                    </template>
                                </div>
                               
                                <div v-if="oldProductInfo.intoCabinType === '0'" class="newOrderInfoTable">
                                    <div class="newOrderInfoTableHd"><span>{{$t('message.bookingData')}}</span></div>
                                    <table id="newBookSpaceTab"
                                           class="planTab"
                                           cellspacing="0">
                                        <tbody>
                                            <tr>
                                                <td>{{$t('message.bookingPieces')}}</td>
                                                <td>{{$t('message.bookingWeight')}}</td>
                                                <td>{{$t('message.bookingVolume')}}</td>
                                                <td>{{$t('message.bookingProportion')}}</td>
                                            </tr>
                                            <tr>
                                                <td class="pieces">{{oldProductInfo.bookingData.pieces}}</td>
                                                <td class="weight">{{oldProductInfo.bookingData.weight}}</td>
                                                <td class="volume">{{oldProductInfo.bookingData.volume}}</td>
                                                <td>1:<span
                                                        class="proportion">{{oldProductInfo.bookingData.proportion}}</span>
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                                <div v-else class="newIntoInfoTable">
                                    <div class="newIntoInfoTableHd"><span>{{$t('message.entryData')}}</span></div>
                                    <table id="newIntoSpaceTab"
                                           class="planTab"
                                           cellspacing="0">
                                        <tbody>
                                            <tr>
                                                <td>{{$t('message.bookingPieces')}}</td>
                                                <td>{{$t('message.bookingWeight')}}</td>
                                                <td>{{$t('message.bookingVolume')}}</td>
                                                <td>{{$t('message.bookingProportion')}}</td>
                                            </tr>
                                            <tr>
                                                <td class="pieces">{{oldProductInfo.intoCabin.pieces}}</td>
                                                <td class="weight">{{oldProductInfo.intoCabin.weight}}</td>
                                                <td class="volume">{{oldProductInfo.intoCabin.volume}}</td>
                                                <td class="proportion">{{'1:'+oldProductInfo.intoCabin.proportion}}</td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                                <div class="priceCompare">
                                    <p class="priceCompareTit"><span>{{$t('message.priceCompared')}}</span></p>
                                    <p class="changePrice">
                                        <span class="iconfont icon-alert iconStress"></span>
                                        <span v-if="Number(bookDetailData.differPrice) > 0" class="priceChangeCon">{{$t('message.rise')}}{{$currencyAbbr(currencyType)}}{{Number(bookDetailData.differPrice).toFixed(2)}}</span>
                                        <span v-else-if="Number(bookDetailData.differPrice) == 0"
                                              class="priceChangeCon">{{$t('message.flat')}}</span>
                                        <span v-else-if="Number(bookDetailData.differPrice) < 0" class="priceChangeCon">{{$t('message.economize')}}{{$currencyAbbr(currencyType)}}{{Math.abs(Number(bookDetailData.differPrice)).toFixed(2)}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </el-collapse-transition>
                </div>
                <div class="orderCompareFt">
                    <el-button v-show="changeDateSubmit"
                               class="confirm"
                               size="mini"
                               type="primary"
                               :disabled="vernegotiatedPrice || (yijiaOpen && !Number(negotiatedPrice))"
                               @click="eventReduce()">{{$t('message.submit')}}
                    </el-button>
                    <a href="javascript:void(0);"
                       class="cancel"
                       @click="changeDateCancel">{{$t('message.back')}}</a>
                </div>
            </div>
        </div>
        <!--人工审核弹窗-->
        <el-dialog
                :visible.sync="manualReviewMask"
                :title="$t('message.promptMessage')"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                class="manualReviewMask">
            <div class="manualReviewPop">
                <template v-if="$overseasType">
                    <p class="tips">{{$t('message.manualReviewTipsEn')}}</p>
                    <div class="emailInputBox">
                        <el-input v-model.trim="reviewEmail"
                                  :placeholder="$t('message.pleaseEnterEmail')"
                                  size="mini"
                                  :class="{errIpt:emailErrTips}"
                                  @focus="emailErrTips=false"
                                  @blur="emailBlurInspect"></el-input>
                    </div>
                    <el-collapse-transition>
                        <p v-show="emailErrTips" class="errTips">{{$t('message.pleaseEnterTrueEmail')}}</p>
                    </el-collapse-transition>
                </template>
                <template v-else>
                    <p class="tips">{{$t('message.mobileFillTip')}}</p>
                    <div style="display: flex;">
                        <el-select v-model="SMSCode"
                                   size="mini"
                                   class="areaCode">
                            <el-option
                                    v-for="(item, index) in SMS"
                                    :key="index"
                                    :label="`+${item.countryCode}`"
                                    :value="item.countryCode">
                                <span style="float: left;">{{`${item.countryNameC}${item.codeAbbr}(+${item.countryCode})`}}</span>
                            </el-option>
                        </el-select>
                        <el-input v-model.trim="reviewMobile"
                                  :placeholder="$t('message.pleaseEnterPhoneNumber')"
                                  size="mini"
                                  :class="{errIpt:mobileErrTips}"
                                  class="mobileInput"
                                  @focus="mobileErrTips=false"
                                  @blur="mobileBlurInspect"></el-input>
                    </div>
                    <el-collapse-transition>
                        <p v-show="mobileErrTips" class="errTips">{{$t('message.pleaseEnterTruePhoneNumber')}}</p>
                    </el-collapse-transition>
                </template>
                <el-button type="primary"
                           class="continueBtn"
                           size="mini"
                           :disabled="continueDisabled"
                           @click="continueBtnClick">
                    {{$t('message.continue')}}
                </el-button>
            </div>
        </el-dialog>
        <el-dialog  title=""
                    :visible.sync="emptyCabinFeeDialog"                           
                    :close-on-click-modal="false" 
                  
                    width="375px"
        >                              
           
            <h3 style="margin-top: -10px; text-align: center; word-break: break-word;">
                此次改期将产生¥{{emptyCabinFee ? emptyCabinFee : '--'}}空舱费是否改期？
            </h3>
            <h3 style="margin-top: 30px; text-align: right;">
                <el-button type="primary" @click="emptyCabinFeeDialog = false">取消</el-button>
                <el-button type="primary" @click="postOrderBillReschedulingDataAjax">{{$t('message.confirm')}}</el-button>
            </h3>
                
        </el-dialog>
        <el-dialog  title=""
                    :visible.sync="eventReduceDialog"                           
                    :close-on-click-modal="false"                 
                    width="375px"
        >                              
           
            <h3 style="margin-top: -10px; text-align: left; word-break: break-word;">
                该订单为活动订单，改期后将不再享受活动优惠，是否改期？
            </h3>
            <h3 style="margin-top: 30px; text-align: right;">
                <el-button type="primary" @click="eventReduceDialog = false">取消</el-button>
                <el-button type="primary" @click="opendialog();eventReduceDialog = false">{{$t('message.confirm')}}</el-button>
            </h3>
                
        </el-dialog>
        <!-- 仓库信息变更公告 -->
        <!-- <WarehouseChangeDialog ref="warehouseChangeDialog" :show="warehouseChangeIsShow"></WarehouseChangeDialog> -->
        <!--加载中-->
        <SJMLoading v-if="isShowLoading" :top="'60%'"></SJMLoading>
    </div>
</template>
<script>
    // 货延险组件
    import GoodsExtensionInsuranceDialog from '@/components/personalCenter/GoodsExtensionInsuranceDialog.vue';
    // 仓库信息变更公告
    // import WarehouseChangeDialog from '@/components/WarehouseChangeDialog';
    // 短信前缀列表
    import SMS from '@/assets/json/SMS.json';

    export default {
        name: 'ChangeDate',
        components: {
            // 货延险组件
            GoodsExtensionInsuranceDialog,
            // 仓库信息变更公告
            // WarehouseChangeDialog
        },
        data() {
            return {
                // 获取地址栏参数
                urlParams: this.$route.query,
                // 改期提交abort
                changeDateSubmitAbort: null,
                // 全局加载中
                isShowLoading: false,
                // 原订舱信息
                oldProductInfo: {
                    // 订舱数据
                    bookingData: {},
                    // 进仓数据
                    intoCabin: {},
                    // 电商货
                    ecargoType: '0',
                    // 是否含电池 0-N、1-Y
                    hasBatteryType: '',
                    // 计费重量
                    feeWeight: '',
                    // 分泡比例（具体比例，如：2/8 || 不分泡）（有降价根据降价后单价）
                    bubbleRatio: '',
                },
                // 产品货延险信息
                goodsExtensionInsurance: {
                    // 用户信息
                    userInfo: {}
                },
                // 新订舱信息列表
                newProductInfoList: [],
                // 正装备装
                bookingPosition: '',
                // 托散
                packageWay: '',
                // 航班日期索引
                flightDateSel: '',
                // 左侧
                changeDateLt: false,
                // 右侧
                changeDateRt: false,
                // 货延险模块
                goodsExtensionInsuranceMod: false,
                // 航班日期
                flightDate: '',
                // 订舱详情数据
                bookDetailData: {
                    quotedPriceId: '',// 报价id
                    spacePercentage: '',// 仓位百分比
                    realPrice: '',// 实际单价
                    differPrice: '0',// 与原订舱价格差价
                    bubbleRatio: '',// 分泡比例（具体比例，如：2/8 || 不分泡）
                    negotiatedPriceRange: '',// 议价范围（负数，无返回空）
                    customerCompensationRatio: '',// 客户赔付比例（无返回空）
                    supplierCompensationRatio: '',// 供应商赔付比例（无返回空）
                    feeWeight: '',// 计费重量
                    // 货延险信息
                    insuranceInfo: {
                        plan1: {},
                        plan2: {},
                        plan3: {}
                    }
                },
                // 货延险发送信息
                insuranceSendInfo: {},
                // 航班报价id
                quotedPriceId: '',
                // 原订舱信息模块动画
                oldOrderModAni: false,
                // 新订舱信息模块
                newOrderMod: false,
                // 改期提交
                changeDateSubmit: false,
                // 正装备装
                suitReadinessArr: [
                    this.$t('message.formal'),
                    this.$t('message.spare')
                ],
                // 散货托盘
                bulkTrayArr: [
                    this.$t('message.bulk'),
                    this.$t('message.tray')
                ],
                // 人工审核弹窗
                manualReviewMask: false,
                // 币种
                currencyType: '',
                // 操作单价
                operationPrice: '',
                // 利润单价
                profitPrice: '',
                // 手机号正则
                mobileReg: this.$store.state.Regular.mobile,
                // 邮箱正则
                emailReg: this.$store.state.Regular.email,
                // 用户手机号
                reviewMobile: '',
                // 用户邮箱
                reviewEmail: '',
                // 手机号错误提示
                mobileErrTips: false,
                // 邮箱错误提示
                emailErrTips: false,
                // 被选中的方案
                activePlan: '',
                // 时间戳（恢复默认货延险显示方案信息）
                timeStamp: -1,
                SMS: SMS,// 短信前缀列表
                SMSCode: '86',// 短信前缀
                // 继续按钮禁用状态
                continueDisabled: false,
                // 仓库信息变更公告
                // warehouseChangeIsShow: -1,
                negotiatedPrice: '',
                vernegotiatedPrice: false,
                yijiaOpen: false,
                emptyCabinFee: '',
                emptyCabinFeeDialog: false,
                eventReduceDialog: false
            };
        },
        created() {
            // 获取 改期页面数据ajax
            this.getChangeDateAjax();
        },
        methods: {
            inpt() {       		
                let negotiatedPrice1 = this.$filterNumber({
                    value: this.negotiatedPrice,
                    fixed: 2,
                    min: 0,
                    max: 999999999.99,
                    ebleEmpty: true
                });
                if (!negotiatedPrice1) {
                    this.negotiatedPrice = '';
                    this.vernegotiatedPrice = false;  
                } else {
                    this.negotiatedPrice = negotiatedPrice1;
                    if (Number(this.negotiatedPrice) <= -Number(this.bookDetailData.negotiatedPriceRange)) {
                        this.vernegotiatedPrice = false;  
                    } else {
                        this.vernegotiatedPrice = true;  
                    }  
   
                }
            },
            // 获取 改期页面数据ajax
            getChangeDateAjax() {
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/ChangeDateHandler.ashx',
                    data: {
                        act: 'getOrderBillReschedulingData',// 获取 改期页面数据
                        orderBillCode: this.urlParams.orderBillCode,// 托单号
                    },
                    beforeSend: () => {
                        // 加载中添加
                        this.isShowLoading = true;
                    },
                    errCallback: () => {
                        // 跳回出口主页
                        this.$router.push({
                            path: '/personalCenter/PersonalCenterMain'
                        });
                    },
                    success: (res) => {
                        // 原订舱信息
                        this.oldProductInfo = res.success.oldProductInfo;
                        // 产品货延险信息
                        this.goodsExtensionInsurance = res.success.goodsExtensionInsurance;
                        // 新订舱信息列表
                        this.newProductInfoList = res.success.newProductInfoList;
                        // 币种
                        this.currencyType = res.success.currencyType;
                        // 操作单价
                        this.operationPrice = res.success.operationPrice;
                        // 利润单价
                        this.profitPrice = res.success.profitPrice;
                        // 渲染 正备装和托盘散货
                        this.suitAndBulkTem();
                        // 左侧显示
                        this.changeDateLt = true;
                        // 右侧显示
                        this.changeDateRt = true;
                    },
                    complete: () => {
                        // 加载中移除
                        this.isShowLoading = false;
                    }
                });
            },
            // 渲染 正备,托散
            suitAndBulkTem() {
                // 默认正装
                this.bookingPosition = '0';
                // 托盘散货
                this.packageWay = this.oldProductInfo.packageWay;
            },
            // 日期转周几
            weekdaySet(data) {
                let date = new Date(data);
                let index = date.getDay();
                let week = '';
                switch (index) {
                    case 1:
                        week = this.$t('message.monday');
                        break;
                    case 2:
                        week = this.$t('message.tuesday');
                        break;
                    case 3:
                        week = this.$t('message.wednesday');
                        break;
                    case 4:
                        week = this.$t('message.thursday');
                        break;
                    case 5:
                        week = this.$t('message.friday');
                        break;
                    case 6:
                        week = this.$t('message.saturday');
                        break;
                    case 0:
                        week = this.$t('message.sunday');
                        break;
                }
                return week;
            },
            // 航班日期选择
            flightDateSelect(index, flag) {
                // 无航班，无报价
                if (flag !== '') {
                    return;
                }
                // 时间戳更改(恢复默认货延险显示方案信息)
                this.timeStamp = +new Date();
                // 航班日期选中索引
                this.flightDateSel = index;
                // 航班日期
                this.flightDate = this.newProductInfoList[this.flightDateSel].date;
                // 判断正备，托散
                if (this.bookingPosition === '0') {// 正装
                    // 产品货延险标志
                    if (this.goodsExtensionInsurance.insuranceType === '1') {
                        // 货延险模块展开
                        this.goodsExtensionInsuranceMod = true;
                    }
                    if (this.packageWay === '0') {// 散货
                        // 订舱详情数据
                        this.bookDetailData = this.newProductInfoList[this.flightDateSel].suit.bulkCargo;
                        this.negotiatedPrice = '';
                        this.vernegotiatedPrice = false; 
                        this.yijiaOpen = false;
                    } else if (this.packageWay === '1') {// 托盘
                        // 订舱详情数据
                        this.bookDetailData = this.newProductInfoList[this.flightDateSel].suit.tray;
                        this.negotiatedPrice = '';
                        this.vernegotiatedPrice = false; 
                        this.yijiaOpen = false;
                    }
                } else if (this.bookingPosition === '1') {
                    // 货延险模块隐藏
                    this.goodsExtensionInsuranceMod = false;
                    if (this.packageWay === '0') {// 散货
                        // 订舱详情数据
                        this.bookDetailData = this.newProductInfoList[this.flightDateSel].readiness.bulkCargo;
                        this.negotiatedPrice = '';
                        this.vernegotiatedPrice = false;
                        this.yijiaOpen = false; 
                    } else if (this.packageWay === '1') {// 托盘
                        // 订舱详情数据
                        this.bookDetailData = this.newProductInfoList[this.flightDateSel].readiness.tray;
                        this.negotiatedPrice = '';
                        this.vernegotiatedPrice = false;
                        this.yijiaOpen = false; 
                    }
                }
                // 航班报价id
                this.quotedPriceId = this.bookDetailData.quotedPriceId;
                // 原订舱信息模块
                this.oldOrderModAni = true;
                // 新订舱信息模块
                this.newOrderMod = true;
                // 改期提交显示
                this.changeDateSubmit = true;
            },
            // 正备装选择
            suitReadinessSel(index) {
                if (index === 1 && this.urlParams.orderBillCode.indexOf('DSJK') >= 0) {
                    return;
                }
                if (this.oldProductInfo.ecargoType === '1') {
                    return;
                }
                this.bookingPosition = String(index);
                // 时间戳更改（恢复默认货延险显示方案信息）
                this.timeStamp = +new Date();
                // 判断是否已选日期
                if (this.flightDateSel !== '') {
                    this.flightDateSelect(this.flightDateSel, '');
                }
                // 大数据
                this.$bigData('suitReadinessItem', '正备装切换', this.urlParams.orderBillCode + '+' + this.bookingPosition);
            },
            // 散货托盘选择
            bulkTraySel(index, flag) {
                if (flag === '1') {// 有进仓数据
                    // 判断打包方式是否发生改变
                    if (this.packageWay !== String(index)) {
                        this.$Alert({msg: this.$t('message.existingWarehouseData')});
                    }
                    return;
                }
                if (this.oldProductInfo.ecargoType === '1') {
                    return;
                }
                this.packageWay = String(index);
                // 时间戳更改（恢复默认货延险显示方案信息）
                this.timeStamp = +new Date();
                // 判断是否已选日期
                if (this.flightDateSel !== '') {
                    this.flightDateSelect(this.flightDateSel, '');
                }
                // 大数据
                this.$bigData('bulkTrayItem', '散货托盘选择', this.urlParams.orderBillCode + '+' + this.packageWay);
            },
            // // 改期点击提交
            // async changeDateSubmitClick() {
            //     // 仓库信息变更公告
            //     await this.showWarehouseChange();
            //     // 改期提交点击 ajax
            //     this.postOrderBillReschedulingDataAjax();
            // },
            // // 仓库信息变更公告
            // showWarehouseChange() {
            //     // 打开弹窗
            //     this.warehouseChangeIsShow = Math.random();
            //     // 监听emit confirm 回调
            //     return new Promise(resolve => {
            //         this.$refs.warehouseChangeDialog.$on('confirm', () => {
            //             resolve();
            //         });
            //     });
            // },
            // 改期提交点击 ajax
            eventReduce() {
                if (this.$route.query.eventReduce) {
                    this.eventReduceDialog = true;                
                } else {
                    this.opendialog();
                }
            },
            opendialog() {
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/unManned/OrderLockPriceHandler.ashx',
                    data: {
                        act: 'getMallOrderQueryEmptyCabinFeeData',// 获取商城订单查询空舱费的数据
                        orderBillCode: this.urlParams.orderBillCode// 托单号
                    },
                    beforeSend: () => {
                        this.isShowLoading = true;
                    },
                    success: (res) => {
                        this.emptyCabinFee = res.success.emptyCabinFee;  
                        this.isShowLoading = false;
                        if (Number(this.emptyCabinFee)) {
                            this.emptyCabinFeeDialog = true;
                        } else {
                            setTimeout(() => {
                                this.postOrderBillReschedulingDataAjax();
                            }, 0);                   
                        }
                    },
                    complete: () => {
                        this.isShowLoading = false;
                    } 

                });
            },
            postOrderBillReschedulingDataAjax() {
                
                this.$ajax({
                    name: 'changeDateSubmitAbort',
                    url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/ChangeDateHandler.ashx',
                    data: {
                        act: 'postOrderBillReschedulingData',// 提交 改期数据
                        orderBillCode: this.urlParams.orderBillCode,// 托单号
                        date: this.flightDate,// 日期
                        bookingPosition: this.bookingPosition,// 0-正装、1-备装
                        way: this.packageWay,// 散货=0、托盘=1
                        quotedPriceId: this.quotedPriceId,// 报价id
                        // 货延险（若未购买 则传空对象）
                        goodsExtensionInsurance: JSON.stringify(this.insuranceSendInfo),
                        negotiatedPrice: this.negotiatedPrice ? '-' + this.negotiatedPrice : '',// 议价减价
                    },
                    beforeSend: () => {
                        // 加载中添加
                        this.isShowLoading = true;
                        this.emptyCabinFeeDialog = false;
                    },
                    success: (res) => {
                        // 判断 订舱成功回调 不为空
                        if (res.success.msgContent) {
                            this.$Alert({
                                msg: res.success.msgContent,
                                callback: () => {
                                    if (res.success.manualReview === '0') {// 不审核
                                        this.$Alert({
                                            msg: this.$t('message.rescheduleSuccess'),
                                            type: 'success',
                                            callback: () => {
                                                // 跳回出口主页
                                                this.$router.push({
                                                    path: '/personalCenter/PersonalCenterMain'
                                                });
                                            }
                                        });
                                    } else if (res.success.manualReview === '1') {// 人工审核
                                        // 判断是海外用户
                                        if (!this.$overseasType) {// 非海外
                                            // 短信前缀
                                            this.SMSCode = this.$SMS(res.success.reviewMobile).SMSCode;
                                            // 用户手机号
                                            this.reviewMobile = this.$SMS(res.success.reviewMobile).mobile;
                                        } else {// 海外
                                            // 用户邮箱
                                            this.reviewEmail = res.success.reviewEmail;
                                        }
                                        // 人工审核弹窗
                                        this.manualReviewMask = true;
                                    }
                                }
                            });
                        } else {
                            if (res.success.manualReview === '0') {// 不审核
                                this.$Alert({
                                    msg: this.$t('message.rescheduleSuccess'),
                                    type: 'success',
                                    callback: () => {
                                        // 跳回出口主页
                                        this.$router.push({
                                            path: '/personalCenter/PersonalCenterMain'
                                        });
                                    }
                                });
                            } else if (res.success.manualReview === '1') {// 人工审核
                                // 判断是海外用户
                                if (!this.$overseasType) {// 非海外
                                    // 短信前缀
                                    this.SMSCode = this.$SMS(res.success.reviewMobile).SMSCode;
                                    // 用户手机号
                                    this.reviewMobile = this.$SMS(res.success.reviewMobile).mobile;
                                } else {// 海外
                                    // 用户邮箱
                                    this.reviewEmail = res.success.reviewEmail;
                                }
                                // 人工审核弹窗
                                this.manualReviewMask = true;
                            }
                        }

                    },
                    complete: () => {
                        // 加载中移除
                        this.isShowLoading = false;
                    }
                });
                // 大数据
                this.$bigData('submitClick', '改期提交', this.urlParams.orderBillCode + '+' + this.flightDate);

            },
            // 取消按钮点击
            changeDateCancel() {
                // 跳回出口主页
                this.$router.push({
                    path: '/personalCenter/PersonalCenterMain'
                });
                // 大数据
                this.$bigData('returnClick', '改期返回', this.urlParams.orderBillCode);

            },
            // 手机号失焦检验
            mobileBlurInspect() {
                // 正则匹配手机号
                if (!this.mobileReg.test(this.reviewMobile)) {
                    this.mobileErrTips = true;
                }
            },
            // 邮箱失焦检验
            emailBlurInspect() {
                // 正则匹配邮箱
                if (!this.emailReg.test(this.reviewEmail)) {
                    this.emailErrTips = true;
                }
            },
            // 继续按钮点击
            continueBtnClick() {
                // 判断用户类型 true-海外 false-国内
                if (this.$overseasType) {
                    // 正则匹配邮箱
                    if (this.emailReg.test(this.reviewEmail)) {
                        // 人工审核 继续按钮ajax
                        this.continueBtnClickAjax();
                        // 大数据
                        this.$bigData('continueBtn', '继续', this.urlParams.orderBillCode + '+' + this.reviewEmail);
                    }
                } else {
                    // 正则匹配手机号
                    if (this.mobileReg.test(this.reviewMobile)) {
                        // 人工审核 继续按钮ajax
                        this.continueBtnClickAjax();
                        // 大数据
                        this.$bigData('continueBtn', '继续', this.urlParams.orderBillCode + '+' + this.reviewMobile);
                    }
                }
            },
            // 人工审核 继续按钮ajax
            continueBtnClickAjax() {
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/ChangeDateHandler.ashx',
                    data: {
                        act: 'postOrderBillReschedulingManualReviewData',// 提交 改期 人工审核 手机号数据
                        orderBillCode: this.urlParams.orderBillCode,// 托单号
                        mobile: this.reviewMobile,// 手机号
                        email: this.reviewEmail// 邮箱
                    },
                    beforeSend: () => {
                        // 继续按钮禁用状态
                        this.continueDisabled = true;
                    },
                    success: () => {
                        // 提交成功
                        this.$Alert({
                            msg: this.$t('message.rescheduleWaitReview'),
                            type: 'success',
                            callback: () => {
                                // 跳回出口主页
                                this.$router.push({
                                    path: '/personalCenter/PersonalCenterMain'
                                });
                            }
                        });
                    },
                    complete: () => {
                        // 继续按钮禁用状态
                        this.continueDisabled = false;
                    }
                });
            },
            // 货延险方案回调
            insurancePlanFn(val) {
                // 方案
                this.activePlan = val;
                if (this.activePlan === '') {
                    // 货延险发送信息
                    this.insuranceSendInfo = {};
                } else {
                    // 货延险发送信息
                    // 方案
                    this.insuranceSendInfo.plan = this.activePlan;
                    // 企业用户数据
                    this.insuranceSendInfo.taxId = this.goodsExtensionInsurance.userInfo.taxId;
                    // 合伙人数据
                    this.insuranceSendInfo.realName = this.goodsExtensionInsurance.userInfo.realName;
                    this.insuranceSendInfo.idCard = this.goodsExtensionInsurance.userInfo.idCard;
                }
            }

        },
    };
</script>

<style lang="scss" scoped>
    /* 主要样式 */
    #changeDate {
        position: relative;
        width: 1070px;
        min-height: 509px;

        /* padding: 25px; */
        overflow: hidden;
        background-color: #fff;
    }

    #changeDate .changeDateLt {
        float: left;
        width: 372px;
        padding: 25px 0 0 25px;
    }

    #transportType {
        display: flex;
        width: 370px;
        padding: 3px 0;
        margin: 20px 0 0 0;
        font-size: 14px;
        color: #727171;
        border: 1px solid #3e3a39;
    }

    #transportType span {
        display: inline-block;
        padding: 2px 6px;
        text-align: center;
        border-radius: 2px;
    }

    #transportType span.active {
        color: #fff;
        background-color: #00a0e9;
    }

    #transportType .suitReadiness {
        display: flex;
        flex: 1;
        justify-content: space-around;
        border-right: 1px dashed #3e3a39;
    }

    #transportType .suitReadiness .suitReadinessItem {
        cursor: pointer;
    }

    #transportType .bulkTray {
        display: flex;
        flex: 1;
        align-items: center;
        justify-content: space-around;
    }

    #transportType .bulkTray .bulkTrayItem {
        cursor: pointer;
    }

    #changeDate .changeDateRt {
        float: right;
        width: 622px;
        padding: 0 25px 20px 0;
        margin: 44px 0 0 0;

        /* height: 835px; */
        border-left: 1px solid #3e3a39;
    }

    #goodsExtensionInsurance {
        width: 610px;
        margin: 0 0 40px 20px;
        border: 1px dashed #3e3a39;
    }

    /* 航班日期css */
    #flight-date .date-title {
        padding-bottom: 20px;
        font-size: 18px;
        color: #2e7ab9;
    }

    #flight-date li {
        position: relative;
        float: left;
        width: 110px;
        height: 66px;
        margin: 0 8px 10px 0;
        overflow: hidden;
        list-style: none;
        cursor: pointer;
        user-select: none;
        background-color: #f2f2f2;
        border: 1px solid transparent;
        transition: all 0.2s linear;
    }

    #flight-date li:not(.noShadow):hover {
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
    }

    #flight-date li.noShadow:hover {
        cursor: not-allowed;
    }

    #flight-date li.active:not(.noShadow) {
        background-color: #dcf1fc;
        border: 1px solid #dcf1fc;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
    }

    #flight-date .flight-date-top {
        height: 24px;
        overflow: hidden;
        line-height: 24px;
        text-align: center;
        border-bottom: 1px dashed #b5b5b5;
    }

    #flight-date .flight-date-top span {
        font-size: 14px;
    }

    #flight-date .flight-date-top .date {
        float: left;
        width: 54px;
        height: 100%;
        border-right: 1px dashed #b5b5b5;
    }

    #flight-date .flight-date-top .week {
        float: left;
        width: 54px;
        height: 100%;
    }

    #flight-date .flight-date-bot {
        margin: 1px 0;
        text-align: center;

        .suit,
        .readiness {
            > span {
                display: inline-block;
                width: 53px;
                text-align: center;
            }
        }
    }

    #flight-date .flight-date-bot .progress {
        display: inline-block;
        width: 50px;
        height: 6px;
        overflow: visible;
        border: 1px solid #c8c8c8;
        border-radius: 10px;
        box-shadow: none;
    }

    #flight-date .flight-date-bot .progress .progress-bar {
        position: relative;
        height: 100%;
        border-radius: 10px;
        transition: width 1s;
    }

    #flight-date .flight-date-bot .suit .progress-bar {
        width: 0%;
        background: #b91d90;
    }

    #flight-date .flight-date-bot .readiness .progress-bar {
        width: 0%;
        background: #1fafd0;
    }

    #flight-date .date-mask {
        position: absolute;
        top: 70px;
        width: 100%;
        height: 100%;
        text-align: center;
        background-color: rgba(0, 0, 0, 0.6);
        transition: top 500ms;
    }

    #flight-date .date-mask span {
        display: inline-block;
        padding-top: 30px;
        font-size: 18px;
        color: #fff;
    }

    #flight-date .date-mask p span {
        padding-top: 6px;
    }

    #date-box {
        overflow: hidden;
    }

    #orderCompare {
        margin: 0 0 0 28px;
    }

    #orderCompare .orderCompareBd {
        overflow: hidden;
    }

    #oldOrder {
        position: relative;
        left: 157px;
        float: left;
        width: 280px;

        /* height: 380px; */
        background-color: #efefef;
    }

    #oldOrder .oldOrderBd {
        position: relative;
        width: 240px;

        /* height: 340px; */
        padding: 10px 10px 70px 10px;
        margin: 10px;
        border: 1px dashed #3e3a39;
    }

    #oldOrder .oldOrderBd .productTypeIcon {
        position: absolute;
        top: 10px;
        left: 10px;
        width: 21px;
        height: 21px;
        background-repeat: no-repeat;
        background-size: cover;
    }

    #oldOrder .oldOrderBd .productTypeIcon.preference_self {
        background-image: url("~@/assets/img/personalCenter/operationCenter/cargoQuery/exportBusiness/cargoFinanceManagementMain/preference_self.png");
    }

    #oldOrder .oldOrderBd .productTypeIcon.preference_logistics {
        background-image: url("~@/assets/img/personalCenter/operationCenter/cargoQuery/exportBusiness/cargoFinanceManagementMain/preference_logistics.png");
    }

    #oldOrder .oldOrderBd .oldOrderInfoHd {
        margin: 10px 0 15px;
        text-align: center;
    }

    #oldOrder .oldOrderBd .oldOrderInfoHd span {
        display: inline-block;
        width: 161px;
        padding: 4px 0;
        font-size: 16px;
        color: #fff;
        background-color: #727171;
        border-radius: 4px;
    }

    #oldOrder .oldOrderBd .oldOrderInfoBd {
        margin: 0 0 0 10px;
        font-size: 16px;

        .through {
            text-decoration: line-through;
        }
    }

    #oldOrder .oldOrderBd .oldOrderInfoBd p {
        margin: 5px 0;
    }

    #oldOrder .oldOrderBd .oldOrderInfoBd span:nth-child(1) {
        color: #727171;
        vertical-align: top;
    }

    #oldOrder .oldOrderBd .oldOrderInfoBd span:nth-child(2) {
        display: inline-block;
        color: #3e3a39;
    }

    #oldOrder .oldOrderBd .oldOrderInfoTable,
    #oldOrder .oldOrderBd .oldIntoInfoTable {
        margin: 12px 0 0 0;
    }

    #oldOrder .oldOrderBd .oldOrderInfoTable .oldOrderInfoTableHd,
    #oldOrder .oldOrderBd .oldIntoInfoTable .oldIntoInfoTableHd {
        margin: 0 0 5px 0;
        font-size: 14px;
        color: #727171;
        text-align: center;
    }

    #oldOrder .oldOrderBd .oldOrderInfoTable .planTab,
    #oldOrder .oldOrderBd .oldIntoInfoTable .planTab {
        width: 240px;
        height: 55px;
        background-color: #fff;
    }

    #oldOrder .oldOrderBd .oldOrderInfoTable .planTab tr:nth-child(1),
    #oldOrder .oldOrderBd .oldIntoInfoTable .planTab tr:nth-child(1) {
        font-size: 12px;
        color: #727171;
    }

    #oldOrder .oldOrderBd .oldOrderInfoTable .planTab tr:nth-child(2),
    #oldOrder .oldOrderBd .oldIntoInfoTable .planTab tr:nth-child(2) {
        font-size: 14px;
        color: #3e3a39;
    }

    #oldOrder .oldOrderBd .oldOrderInfoTable .planTab td,
    #oldOrder .oldOrderBd .oldIntoInfoTable .planTab td {
        border-right: 1px solid #727171;
        border-bottom: 1px solid #727171;
    }

    #oldOrder .oldOrderBd .oldOrderInfoTable .planTab td:nth-child(4),
    #oldOrder .oldOrderBd .oldIntoInfoTable .planTab td:nth-child(4) {
        border-right: none;
    }

    #oldOrder .oldOrderBd .oldOrderInfoTable tr:last-child td,
    #oldOrder .oldOrderBd .oldIntoInfoTable tr:last-child td {
        border-bottom: none;
    }

    #newOrder {
        float: right;
        width: 280px;

        /* height: 380px; */
        background-color: #e3eff6;
    }

    #newOrder .newOrderBd {
        position: relative;
        width: 240px;

        /* height: 340px; */
        padding: 10px;
        margin: 10px;
        border: 1px dashed #00a0e9;
    }

    #newOrder .newOrderBd .productTypeIcon {
        position: absolute;
        top: 10px;
        left: 10px;
        width: 21px;
        height: 21px;
        background-repeat: no-repeat;
        background-size: cover;
    }

    #newOrder .newOrderBd .productTypeIcon.preference_self {
        background-image: url("~@/assets/img/personalCenter/operationCenter/cargoQuery/exportBusiness/cargoFinanceManagementMain/preference_self.png");
    }

    #newOrder .newOrderBd .productTypeIcon.preference_logistics {
        background-image: url("~@/assets/img/personalCenter/operationCenter/cargoQuery/exportBusiness/cargoFinanceManagementMain/preference_logistics.png");
    }

    #newOrder .newOrderBd .newOrderInfoHd {
        margin: 10px 0 15px;
        text-align: center;
    }

    #newOrder .newOrderBd .newOrderInfoHd span {
        display: inline-block;
        width: 161px;
        padding: 4px 0;
        font-size: 16px;
        color: #fff;
        background-color: #005baa;
        border-radius: 4px;
    }

    #newOrder .newOrderBd .newOrderInfoBd {
        margin: 0 0 0 10px;
        font-size: 16px;
    }

    #newOrder .newOrderBd .newOrderInfoBd p {
        margin: 5px 0;
    }

    #newOrder .newOrderBd .newOrderInfoBd span:nth-child(1) {
        color: #727171;
        vertical-align: top;
    }

    #newOrder .newOrderBd .newOrderInfoBd span:nth-child(2) {
        display: inline-block;
        color: #3e3a39;
    }

    #newOrder .newOrderBd .newOrderInfoBd span.change {
        color: #e83828;
    }

    #newOrder .newOrderBd .newOrderInfoTable,
    #newOrder .newOrderBd .newIntoInfoTable {
        margin: 12px 0 0 0;
    }

    #newOrder .newOrderBd .newOrderInfoTable .newOrderInfoTableHd,
    #newOrder .newOrderBd .newIntoInfoTable .newIntoInfoTableHd {
        margin: 0 0 5px 0;
        font-size: 14px;
        color: #727171;
        text-align: center;
    }

    #newOrder .newOrderBd .newOrderInfoTable .planTab,
    #newOrder .newOrderBd .newIntoInfoTable .planTab {
        width: 240px;
        height: 55px;
        background-color: #fff;
    }

    #newOrder .newOrderBd .newOrderInfoTable .planTab tr:nth-child(1),
    #newOrder .newOrderBd .newIntoInfoTable .planTab tr:nth-child(1) {
        font-size: 12px;
        color: #727171;
    }

    #newOrder .newOrderBd .newOrderInfoTable .planTab tr:nth-child(2),
    #newOrder .newOrderBd .newIntoInfoTable .planTab tr:nth-child(2) {
        font-size: 14px;
        color: #3e3a39;
    }

    #newOrder .newOrderBd .newOrderInfoTable .planTab td,
    #newOrder .newOrderBd .newIntoInfoTable .planTab td {
        border-right: 1px solid #727171;
        border-bottom: 1px solid #727171;
    }

    #newOrder .newOrderBd .newOrderInfoTable .planTab td:nth-child(4),
    #newOrder .newOrderBd .newIntoInfoTable .planTab td:nth-child(4) {
        border-right: none;
    }

    #newOrder .newOrderBd .newOrderInfoTable tr:last-child td,
    #newOrder .newOrderBd .newIntoInfoTable tr:last-child td {
        border-bottom: none;
    }

    #newOrder .newOrderBd .priceCompare {
        margin: 15px 0 0 0;
        text-align: center;
    }

    #newOrder .newOrderBd .priceCompare .priceCompareTit {
        font-size: 12px;
        color: #005baa;
    }

    #newOrder .newOrderBd .priceCompare .changePrice span {
        font-size: 22px;
        color: #e83828;
    }

    #newOrder .newOrderBd .priceCompare .iconStress {
        margin: 0 5px 0 0;
    }

    #orderCompare .orderCompareFt {
        margin: 30px 0 0 0;
        text-align: right;
    }

    #orderCompare .orderCompareFt /deep/ .confirm {
        min-width: 50px;
        padding: 7px 5px;
        margin: 0 26px 0 0;
    }

    #orderCompare .orderCompareFt .cancel {
        color: #727171;
    }

    /* 人工审核 */

    .manualReviewMask /deep/ {
        .el-dialog__header {
            text-align: center;

            span {
                font-size: 16px;
                font-weight: bold;
                color: #18a4f9;
            }
        }

        .el-dialog__headerbtn .el-dialog__close {
            display: none;
        }

        .el-dialog {
            width: 430px;
            margin-top: 24vh !important;
        }

        .el-dialog__body {
            padding-top: 10px;
        }

        .areaCode {
            width: 108px;

            .el-input__inner {
                width: 96px;
                height: 32px;
                margin: 10px 20px;
                line-height: 32px;
            }
        }

        .mobileInput {
            flex: 1;
        }

        .mobileInput .el-input__inner {
            width: 250px;
            height: 32px;
            padding-left: 5px;
            margin: 10px 20px;
            font-size: 14px;
            line-height: 34px;
            color: #7e7e7e;
        }

        .errIpt .el-input__inner {
            border: 1px solid rgb(204, 0, 0);
        }

        .el-input .el-input__inner:hover {
            border: 1px solid #0097e0;
        }

        .continueBtn {
            min-width: 100px;
            margin: 0 20px;
            cursor: pointer;
        }

        .emailInputBox {
            padding: 10px 20px;
        }
    }

    .manualReviewMask .tips {
        padding: 0 20px;
        line-height: 20px;
        color: #7e7e7e;
    }

    .manualReviewMask .errTips {
        padding: 0 20px;
        margin-bottom: 10px;
        line-height: 20px;
        color: rgb(204, 0, 0);
    }

    .oldOrderModLeft {
        animation: oldOrderModLtAni 0.35s forwards;
    }

    @keyframes oldOrderModLtAni {
        from {
            left: 157px;
        }

        to {
            left: 0;
        }
    }

</style>


